// extracted by mini-css-extract-plugin
export var button = "_4-0";
export var buttonContent = "_4-e";
export var buttonGroup = "_4-c";
export var dontRestrainIconWidth = "_4-a";
export var dropdownButton = "_4-b";
export var iconContainer = "_4-9";
export var lg = "_4-4";
export var md = "_4-3";
export var pending = "_4-f";
export var sm = "_4-2";
export var spinner = "_4-d";
export var squared = "_4-8";
export var wrapText = "_4-g";
export var xl = "_4-5";
export var xs = "_4-1";
export var xxl = "_4-6";
export var xxxl = "_4-7";